import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  remove(event: Event): void {
    const target = event.target as HTMLElement;
    target?.closest("[data-alerts-item]")?.remove();
  }
}
